import { useState } from "react";
import useVendorStore from "../../../AuthStore/store/authStore";
import { useNavigate } from "react-router-dom";
// import toast from "react-hot-toast";
import showLoginToast from "../../CustomHotToast/CustomToast";




const CustomerSignupForm = ({ onSuccess }) => {
  const { signUpAsUser } = useVendorStore();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firsName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrorMsg("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await signUpAsUser(formData);
      console.log("Customer signup successful:", response);

      showLoginToast.success(response.message || "Signup successful!");
      onSuccess();
      navigate("/log-in");
    } catch (error) {
      
      console.error("Signup  error:", error?.response?.data?.errors);

      const errors = error?.response?.data?.errors;

      if (errors && Object.keys(errors).length > 0) {
        const firstErrorKey = Object.keys(errors)[0];
        setErrorMsg(errors[firstErrorKey][0]);

        showLoginToast.error(errors[firstErrorKey][0]);
        return;
      }


      showLoginToast.error(" email or Phone number Already used!");

      // console.log("Errors object:", Object.keys(errors).length);
      
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <h2 className="text-lg font-bold mb-4 text-center text-green-700">
        Customer Signup
      </h2>

      <input
        name="firsName"
        placeholder="Frist Name"
        value={formData.firsName}
        onChange={handleChange}
        className="w-full border rounded px-3 py-2"
      />
      <input
        name="lastName"
        placeholder="Last Name"
        value={formData.lastName}
        onChange={handleChange}
        className="w-full border rounded px-3 py-2"
      />
      <input
        name="email"
        placeholder="Email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        className="w-full border rounded px-3 py-2"
      />
      <input
        name="phone"
        placeholder="Phone"
        type="tel"
        value={formData.phone}
        onChange={handleChange}
        className="w-full border rounded px-3 py-2"
      />
      <input
        name="password"
        placeholder="Password"
        type="password"
        value={formData.password}
        onChange={handleChange}
        className="w-full border rounded px-3 py-2"
      />

      {errorMsg && <p className="text-red-500 text-sm">{errorMsg}</p>}

      <button
        type="submit"
        className="w-full py-2 bg-green-600 text-white rounded hover:bg-green-700"
        disabled={isSubmitting}
      >
        {isSubmitting ? "Creating Account..." : "Create Account"}
      </button>
    </form>
  );
};



export default CustomerSignupForm;